import React from "react";

import Image, { StaticImageData } from "next/image";

import Geddski from "assets/developers/testimonials/profile-geddski.png";
import Yonben from "assets/developers/testimonials/profile-yonben.png";
import Holman from "assets/developers/testimonials/profile-holman.png";
import Satanworker from "assets/developers/testimonials/profile-satanworker.png";
import Algovc from "assets/developers/testimonials/profile-algovc.png";
import Mauscoelho from "assets/developers/testimonials/profile-mauscoelho.png";
import Dev99problems from "assets/developers/testimonials/profile-dev99problems.png";
import Ricoberger from "assets/developers/testimonials/profile-ricoberger.png";
import GregBrimble from "assets/developers/testimonials/profile-GregBrimble.png";
import Krzysztof from "assets/developers/testimonials/profile-krzysztof_zuraw.png";

import SlackIcon from "assets/developers/testimonials/slack-icon.svg";
import TwitterIcon from "assets/developers/testimonials/twitter-icon.svg";

import ArrowRight from "assets/iconsv2/arrow-right-16.svg";

import Container from "components/Container";

import styles from "./Testimonials.module.css";

type Testimonial = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any;
  type: "twitter" | "slack";
  handle: string;
  avatar: StaticImageData;
  text: string;
};

const testimonials: Testimonial[] = [
  {
    icon: <TwitterIcon />,
    type: "twitter",
    handle: "geddski",
    avatar: Geddski,
    text: "I'm super pumped about @raycastapp extensions, I've always wanted something like this for customizing my mac! Love that you can build extensions in TypeScript/React.",
  },
  {
    icon: <SlackIcon />,
    type: "slack",
    handle: "yonben",
    avatar: Yonben,
    text: "Been using Raycast for a while and showed it to a friend yesterday. I then showed him the extensions but he wanted a Bitbucket one, so I tried and in less than an hour had a basic extension running.",
  },
  {
    icon: <TwitterIcon />,
    type: "twitter",
    handle: "holman",
    avatar: Holman,
    text: "Really digging the new extensions API in @raycastapp. A quick key combo and you can scroll through a big ol' list of community hotkeys and commands, basically. This is what I wanted more than a decade ago in the Alfred days; love it.",
  },
  {
    icon: <TwitterIcon />,
    type: "twitter",
    handle: "satanworker",
    avatar: Satanworker,
    text: "Mac OS apps will always have softest spot for me. @raycastapp mixing React/Node with native tooling for extensions is a killer approach!",
  },
  {
    icon: <TwitterIcon />,
    type: "twitter",
    handle: "algovc",
    avatar: Algovc,
    text: "Exciting milestone for @raycastapp with their new API launch, bringing delightful productivity to developers day-to-day!",
  },
  {
    icon: <TwitterIcon />,
    type: "twitter",
    handle: "mauscoelho",
    avatar: Mauscoelho,
    text: "Developing extensions for @raycastapp is so easy and developer friendly ❤️",
  },
  {
    icon: <TwitterIcon />,
    type: "twitter",
    handle: "dev99problems",
    avatar: Dev99problems,
    text: "So extremely excited that @raycastapp finally opened the Extensions Store, so many great apps are already there 👏",
  },
  {
    icon: <TwitterIcon />,
    type: "twitter",
    handle: "ricoberger",
    text: "Awesome work @raycastapp, it's incredible how easy and fast new extensions can be created",
    avatar: Ricoberger,
  },
  {
    icon: <TwitterIcon />,
    type: "twitter",
    handle: "GregBrimble",
    text: "React? With a drop-in Spotlight replacement on MacOS? Yes, please. brb, converting all my janky shell scripts to beautiful interactive prompts.",
    avatar: GregBrimble,
  },
  {
    icon: <TwitterIcon />,
    type: "twitter",
    handle: "krzysztof_zuraw",
    avatar: Krzysztof,
    text: "I recently started playing with @raycastapp extensions API and I have to say I'm really impressed by how easy is to create an extension 🎉",
  },
];

function hrefForTestimonial(testimonial: Testimonial) {
  if (testimonial.type == "twitter") {
    return `https://twitter.com/${testimonial.handle}`;
  } else {
    return "";
  }
}

const Testimonials: React.FC = () => {
  return (
    <>
      <div className={styles.header}>
        <h3>You&rsquo;re in good company</h3>
        <p className={styles.subtitle}>
          It&rsquo;s still early days, but here&rsquo;s some words of motivation so you know you&rsquo;re in the right
          place
        </p>
      </div>
      <div className={styles.testimonialsContainer}>
        <div className={styles.testimonials}>
          {testimonials.map((testimonial, index) => (
            <div className={styles.testimonial} key={index}>
              <Image src={testimonial.avatar} width={48} height={48} layout="fixed" alt="avatar" />
              <p>“{testimonial.text}”</p>
              <a className={styles.handle} href={hrefForTestimonial(testimonial)} target="_blank" rel="noreferrer">
                <span>{testimonial.icon}</span>@{testimonial.handle}
              </a>
            </div>
          ))}
        </div>
      </div>

      <Container className={styles.joinCommunity}>
        <a href="/community">
          Join the community{" "}
          <i className={styles.arrow}>
            <ArrowRight />
          </i>
        </a>
      </Container>
    </>
  );
};

export default Testimonials;
